import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { LightBoxHeaderProps } from '../types';
import { useLightboxContext } from '../LightboxContext';
import LightboxHeaderCloseIcon from './LightboxHeaderCloseIcon';

import { HEADER_HEIGHT } from './constants';

const LightboxHeader = ({ children, dataTestId, closeButtonTestId }: LightBoxHeaderProps) => {
  const { close } = useLightboxContext();

  return (
    <Stack
      height={HEADER_HEIGHT}
      alignItems="center"
      paddingY="0"
      paddingX={{ default: '2', sm: '4' }}
      gap="0"
      cursor="pointer"
      position="fixed"
      top={0}
      right={0}
      bottom={0}
      left={0}
      data-testid={dataTestId}
      onClick={close}
    >
      {children}
      <LightboxHeaderCloseIcon dataTestId={closeButtonTestId} onClick={close} />
    </Stack>
  );
};

LightboxHeader.displayName = 'LightboxHeader';

export default LightboxHeader;
